import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import veevaPlaceholder from "../images/Veeva-Placeholder.svg";
const GileadModal = (props) => {
  const { openCreateNewtemplate, setOpenCreateNewtemplate, type } = props;

  const closeCreateTemplateModal = () => {
    setOpenCreateNewtemplate(false);
  };

  const goToVeevaApplication = () => {
    setOpenCreateNewtemplate(false);  
    window.open('https://gilead-eame.veevavault.com','_blank').focus();
  }
  return (
    <>
      <Modal
        show={openCreateNewtemplate}
        onHide={closeCreateTemplateModal}
        // className="template-forms"
        dialogClassName="new-template-forms gilead-modal-border veeva-placeholder"
      >
        <Modal.Body>
          <div className="header-label">To create a new {type==1?'Template':'e-Detail'}</div>
          <div className="notify">First, create a Placeholder in PromoMats</div>
          <div>
            <img src={veevaPlaceholder} />
          </div>
          <div
            className="create-new-button promo-btn"
            onClick={goToVeevaApplication}
          >
            GO TO PROMOMATS
          </div>
          <div className="close" onClick={closeCreateTemplateModal}>CLOSE</div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default GileadModal;
